export class storeMinCartController {
    isOpen: boolean;
    items: any;
    cartCount = 0
    cartTotalPrice = 0
    loading = true
    cartUrl
    user
    constructor(private $cart, private $rootScope, private $mPath, private $user, private MyConstant) {
        "ngInject"

    }

    $onInit() {
        this.$mPath.get().then(
            response => {
                this.cartUrl = response.StoreCart
            }
        )
        this.$user.getInfo().then(
            user => {
                this.user = user;
                user.data && this.$cart.moveCart(this.user.data)
                this.calc_cartItem()
                this.$rootScope.$on('cartChange', emit => {
                    this.calc_cartItem()
                })
            }
        )

    }

    private checkHasPreventClose(elem) {
        if (elem) {
            return this.checkHasPreventClose(elem.parentElement)
        }
        else {
            return false;
        }
    }
    removeItem(vendor, salabelIndex) {
        vendor.salabelItems.splice(salabelIndex, 1)
        if (vendor.salabelItems.length == 0) {
            angular.forEach(this.items, (val, key) => {
                if (val.VendorID == vendor.VendorID) {
                    this.$cart.removeVendor(this.user.data, vendor)
                    this.items.splice(key, 1)
                }
            })
        }
        else {
            this.$cart.changeSalabelItem(this.user.data, vendor)
        }
        this.$cart.changeSalabelItem(this.user.data, vendor)
    }

    private calc_cartItem() {
        this.cartCount = 0
        this.cartTotalPrice = 0
        this.loading = true;
        this.items = this.$cart.get(this.user.data)
        this.items.map(vendor => {
            vendor.salabelItems.map(item => {
                this.cartCount += item.count;
                this.cartTotalPrice += item.count * item.FinalPrice;
            })
        })
        this.loading = false;
    }
}





// WEBPACK FOOTER //
// ./src/components/store-min-cart/store-min-cart.controller.ts